import { ACTION_TYPE, REPORT_NAME } from "../constant/reportType";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";
import { alertMessage } from "../../utils/AlertService";
import { useEffect, useRef, useState } from "react";
import { useAppSelector } from "../../redux-toolkit/hooks";
import * as Yup from 'yup';
import { Modal } from "react-bootstrap";
import Loading from "../Loading";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { useBulkSaveInvestmentMasterMutation, useGetInvestmentMasterByIdMutation, useSaveInvestmentMasterMutation, useUpdateInvestmentMasterMutation } from "../../redux-toolkit/services/investmentMasterService";
import { useFindAllInvestmentMandateTypeMutation } from "../../redux-toolkit/services/investmentMandateTypeService";
import { allInvestmentMandateTypeDetails, setAllInvestmentMandateType } from "../../redux-toolkit/slices/investmentMandateTypeSlice";
import { useFindAllFamilyOfficeMasterMutation } from "../../redux-toolkit/services/familyOfficeMasterService";
import { allFamilyOfficeMasterDetails, setAllFamilyOfficeMaster } from "../../redux-toolkit/slices/familyOfficeMasterSlice";
import { format, parseISO } from "date-fns";
import { useBulkSaveAssetTypeMutation, useFindAllAssetTypeMutation, useGetAssetTypeByIdMutation, useSaveAssetTypeMutation, useUpdateAssetTypeMutation } from "../../redux-toolkit/services/assetTypeService";
import { allAssetTypeDetails, setAllAssetType } from "../../redux-toolkit/slices/assetTypeSlice";
import { useBulkSaveAssetsMutation, useFindAllAssetsMutation, useGetAssetRiskAssessmentMutation, useGetAssetsByIdMutation, useSaveAssetsMutation, useUpdateAssetsMutation } from "../../redux-toolkit/services/assetsService";
import { allAssetsDetails, getAssetRiskAssessmentData, setAllAssets, setAssetRiskAssessment } from "../../redux-toolkit/slices/assetsSlice";
import { allEntityTypeMasterDetails, setAllEntityTypeMaster } from "../../redux-toolkit/slices/entityTypeMasterSlice";
import { allEntityMasterDetails, setAllEntityMaster } from "../../redux-toolkit/slices/entityMasterSlice";
import { useFindAllEntityTypeMasterMutation } from "../../redux-toolkit/services/entityTypeMasterService";
import { useFindAllEntityMasterMutation } from "../../redux-toolkit/services/entityMasterService";

type Props = {
    show: boolean;
    setShow: any;
    actionType: ACTION_TYPE;
    reportName: string;
    data: any;
    setCall: any;
    isCategory?: boolean;
    setIsCategory?: any;
};

const validationSchema = Yup.object().shape({
    percentageCompleted: Yup.number()
        .min(0, 'Percentage must be at least 0')
        .max(100, 'Percentage cannot exceed 100'),
});

const FOInvestmentData = (props: Props) => {

    const dispatch = useDispatch();
    const localUserObj: any = getLocalStorageData("localUser");

    const setFieldValueRef: any = useRef(null);

    //states
    const [getByIdData, setGetByIdData]: any = useState([]);
    const [file, setFile]: any = useState<File | null>(null);
    const [file2, setFile2]: any = useState<File | null>(null);
    const [fileName, setFileName] = useState("");
    const [fileName2, setFileName2] = useState("");
    const [activeTab, setActiveTab] = useState<"manual" | "bulk">("manual");
    const [llmType, setLlmType] = useState<"ASSESSMENT" | "ANALYZE" | null>(null);

    //save
    const [saveInvestmentMaster, saveInvestmentMasterResponse] = useSaveInvestmentMasterMutation();
    const [saveAssetType, saveAssetTypeResponse] = useSaveAssetTypeMutation();
    const [saveAssets, saveAssetsResponse] = useSaveAssetsMutation();

    //bulk save
    const [bulkSaveInvestmentMaster, bulkSaveInvestmentMasterResponse] = useBulkSaveInvestmentMasterMutation();
    const [bulkSaveAssetType, bulkSaveAssetTypeResponse] = useBulkSaveAssetTypeMutation();
    const [bulkSaveAssets, bulkSaveAssetsResponse] = useBulkSaveAssetsMutation();

    //update
    const [updateInvestmentMaster, updateInvestmentMasterResponse] = useUpdateInvestmentMasterMutation();
    const [updateAssetType, updateAssetTypeResponse] = useUpdateAssetTypeMutation();
    const [updateAssets, updateAssetsResponse] = useUpdateAssetsMutation();

    //getById mutation
    const [getInvestmentMasterById, investmentMasterByIdResponse] = useGetInvestmentMasterByIdMutation();
    const [getAssetTypeById, assetTypeByIdResponse] = useGetAssetTypeByIdMutation();
    const [getAssetsById, assetsByIdResponse] = useGetAssetsByIdMutation();

    //getData
    const [findAllInvestmentMandateType, findAllInvestmentMandateTypeResponse] = useFindAllInvestmentMandateTypeMutation();
    const [findAllFamilyOfficeMaster, findAllFamilyOfficeMasterResponse] = useFindAllFamilyOfficeMasterMutation();
    const [findAllAssetType, findAllAssetTypeResponse] = useFindAllAssetTypeMutation();
    const [findAllAssets, findAllAssetsResponse] = useFindAllAssetsMutation();

    const [getAssetRiskAssessment, assetRiskAssessmentRes] = useGetAssetRiskAssessmentMutation();
    const [getAllEntityTypes, getAllEntityTypesResponse] = useFindAllEntityTypeMasterMutation();
    const [findAllEntity, findAllEntityResponse] = useFindAllEntityMasterMutation();

    //Data
    const allInvestmentMandateType: any = useAppSelector(allInvestmentMandateTypeDetails);
    const allFamilyOfficeMaster: any = useAppSelector(allFamilyOfficeMasterDetails);
    const allAssetType: any = useAppSelector(allAssetTypeDetails);
    const allAssets: any = useAppSelector(allAssetsDetails);
    const assetRiskAssessment: any = useAppSelector(getAssetRiskAssessmentData);
    const allEntityTypes: any = useAppSelector(allEntityTypeMasterDetails);
    const allEntityMaster: any = useAppSelector(allEntityMasterDetails);

    useEffect(() => {
        if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.INVESTMENT_MASTER) {
                getInvestmentMasterById({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                });
                findAllInvestmentMandateType({
                    token: localUserObj?.token,
                })
                findAllFamilyOfficeMaster({
                    token: localUserObj?.token,
                })
                findAllAssetType({
                    token: localUserObj?.token,
                })
            } else if (props.reportName === REPORT_NAME.ASSET_TYPE) {
                getAssetTypeById({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                });
            } else if (props.reportName === REPORT_NAME.ASSETS) {
                findAllEntity({ token: localUserObj?.token });
                getAllEntityTypes({ token: localUserObj?.token });
                findAllAssetType({ token: localUserObj?.token });
                findAllAssets({ token: localUserObj?.token });
                findAllInvestmentMandateType({ token: localUserObj?.token });
                getAssetsById({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                });
            }

        } else if (props.actionType === ACTION_TYPE.ADD_ACTION) {
            if (props.reportName === REPORT_NAME.INVESTMENT_MASTER) {
                findAllInvestmentMandateType({
                    token: localUserObj?.token,
                })
                findAllFamilyOfficeMaster({
                    token: localUserObj?.token,
                })
                findAllAssetType({
                    token: localUserObj?.token,
                })
            } else if (props.reportName === REPORT_NAME.ASSETS) {
                findAllEntity({ token: localUserObj?.token });
                getAllEntityTypes({ token: localUserObj?.token });
                findAllInvestmentMandateType({ token: localUserObj?.token });
                findAllAssetType({
                    token: localUserObj?.token,
                })
            }

        }
    }, [props.reportName]);

    useEffect(() => {
        if (saveInvestmentMasterResponse.isSuccess) {
            const response: any = saveInvestmentMasterResponse.data;
            alertMessage("Investment Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveInvestmentMasterResponse.isError) {
            let response: any = saveInvestmentMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveInvestmentMasterResponse.isSuccess, saveInvestmentMasterResponse.isError]);

    // bulksave
    useEffect(() => {
        if (bulkSaveInvestmentMasterResponse.isSuccess) {
            const response: any = bulkSaveInvestmentMasterResponse.data;
            alertMessage("Investment Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveInvestmentMasterResponse.isError) {
            let response: any = bulkSaveInvestmentMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveInvestmentMasterResponse.isSuccess, bulkSaveInvestmentMasterResponse.isError]);

    useEffect(() => {
        if (bulkSaveAssetTypeResponse.isSuccess) {
            const response: any = bulkSaveAssetTypeResponse.data;
            alertMessage("Asset Type Master added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveAssetTypeResponse.isError) {
            let response: any = bulkSaveAssetTypeResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveAssetTypeResponse.isSuccess, bulkSaveAssetTypeResponse.isError]);

    useEffect(() => {
        if (bulkSaveAssetsResponse.isSuccess) {
            const response: any = bulkSaveAssetsResponse.data;
            alertMessage("Assets added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (bulkSaveAssetsResponse.isError) {
            let response: any = bulkSaveAssetsResponse?.error;
            alertMessage(response, "error");
        }
    }, [bulkSaveAssetsResponse.isSuccess, bulkSaveAssetsResponse.isError]);

    useEffect(() => {
        if (updateInvestmentMasterResponse.isSuccess) {
            const response: any = updateInvestmentMasterResponse.data;
            alertMessage("Investment Master updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateInvestmentMasterResponse.isError) {
            let response: any = updateInvestmentMasterResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateInvestmentMasterResponse.isSuccess, updateInvestmentMasterResponse.isError]);

    useEffect(() => {
        if (saveAssetTypeResponse.isSuccess) {
            const response: any = saveAssetTypeResponse.data;
            alertMessage("Asset Type added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveAssetTypeResponse.isError) {
            let response: any = saveAssetTypeResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveAssetTypeResponse.isSuccess, saveAssetTypeResponse.isError]);

    useEffect(() => {
        if (updateAssetTypeResponse.isSuccess) {
            const response: any = updateAssetTypeResponse.data;
            alertMessage("Asset Type updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateAssetTypeResponse.isError) {
            let response: any = updateAssetTypeResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateAssetTypeResponse.isSuccess, updateAssetTypeResponse.isError]);

    useEffect(() => {
        if (saveAssetsResponse.isSuccess) {
            const response: any = saveAssetsResponse.data;
            alertMessage("Asset added successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (saveAssetsResponse.isError) {
            let response: any = saveAssetsResponse?.error;
            alertMessage(response, "error");
        }
    }, [saveAssetsResponse.isSuccess, saveAssetsResponse.isError]);

    useEffect(() => {
        if (updateAssetsResponse.isSuccess) {
            const response: any = updateAssetsResponse.data;
            alertMessage("Asset updated successfully", "success");
            props.setCall("Y");
            handleClose();
        } else if (updateAssetsResponse.isError) {
            let response: any = updateAssetsResponse?.error;
            alertMessage(response, "error");
        }
    }, [updateAssetsResponse.isSuccess, updateAssetsResponse.isError]);

    useEffect(() => {
        if (investmentMasterByIdResponse.isSuccess) {
            setGetByIdData(investmentMasterByIdResponse.data);
        } else if (investmentMasterByIdResponse.isError) {
            let response: any = investmentMasterByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [investmentMasterByIdResponse.isSuccess, investmentMasterByIdResponse.isError]);

    useEffect(() => {
        if (assetTypeByIdResponse.isSuccess) {
            setGetByIdData(assetTypeByIdResponse.data);
        } else if (assetTypeByIdResponse.isError) {
            let response: any = assetTypeByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [assetTypeByIdResponse.isSuccess, assetTypeByIdResponse.isError]);

    useEffect(() => {
        if (assetsByIdResponse.isSuccess) {
            setGetByIdData(assetsByIdResponse.data);
        } else if (assetsByIdResponse.isError) {
            let response: any = assetsByIdResponse?.error;
            alertMessage(response, "error");
        }
    }, [assetsByIdResponse.isSuccess, assetsByIdResponse.isError]);

    useEffect(() => {
        if (findAllInvestmentMandateTypeResponse.isSuccess) {
            dispatch(setAllInvestmentMandateType(findAllInvestmentMandateTypeResponse));
        } else if (findAllInvestmentMandateTypeResponse.isError) {
            alertMessage("Error while fetching Investment Mandate Types", "error");
        }
    }, [findAllInvestmentMandateTypeResponse.isSuccess, findAllInvestmentMandateTypeResponse.isError]);

    useEffect(() => {
        if (findAllFamilyOfficeMasterResponse.isSuccess) {
            dispatch(setAllFamilyOfficeMaster(findAllFamilyOfficeMasterResponse));
        } else if (findAllFamilyOfficeMasterResponse.isError) {
            alertMessage("Error while fetching Family Office Masters", "error");
        }
    }, [findAllFamilyOfficeMasterResponse.isSuccess, findAllFamilyOfficeMasterResponse.isError]);

    useEffect(() => {
        if (findAllAssetTypeResponse.isSuccess) {
            dispatch(setAllAssetType(findAllAssetTypeResponse));
        } else if (findAllAssetTypeResponse.isError) {
            alertMessage("Error while fetching Asset Type", "error");
        }
    }, [findAllAssetTypeResponse.isSuccess, findAllAssetTypeResponse.isError]);

    useEffect(() => {
        if (findAllAssetsResponse.isSuccess) {
            dispatch(setAllAssets(findAllAssetsResponse));
        } else if (findAllAssetsResponse.isError) {
            alertMessage("Error while fetching Assets", "error");
        }
    }, [findAllAssetsResponse.isSuccess, findAllAssetsResponse.isError]);

    useEffect(() => {
        if (getAllEntityTypesResponse.isSuccess) {
            dispatch(setAllEntityTypeMaster(getAllEntityTypesResponse));
        } else if (getAllEntityTypesResponse.isError) {
            alertMessage("Error while fetching Entity Types", "error");
        }
    }, [getAllEntityTypesResponse.isSuccess, getAllEntityTypesResponse.isError]);

    useEffect(() => {
        if (findAllEntityResponse.isSuccess) {
            dispatch(setAllEntityMaster(findAllEntityResponse));
        } else if (findAllEntityResponse.isError) {
            alertMessage("Error while fetching Entity Master", "error");
        }
    }, [findAllEntityResponse.isSuccess, findAllEntityResponse.isError]);


    useEffect(() => {
        if (!assetRiskAssessmentRes || !setFieldValueRef.current || !llmType) return;

        if (assetRiskAssessmentRes.isSuccess) {
            if (llmType === "ASSESSMENT") {
                dispatch(setAssetRiskAssessment(assetRiskAssessmentRes));
                alertMessage("Risk Assessment successfull", "success");
                props.setCall("Y");
                handleClose();
            } else if (llmType === "ANALYZE") {
                setFieldValueRef.current(
                    "analyzeReq",
                    "please do comprehensive asset risk analysis with referent to asset type / asset owner"
                );
                setFieldValueRef.current(
                    "analyzeRes",
                    assetRiskAssessmentRes?.data?.data?.llmRes || ""
                );
                alertMessage("Analysis successfull", "success");
            }
            setLlmType(null);
        } else if (assetRiskAssessmentRes.isError) {
            alertMessage("Error while fetching Data from LLM", "error");
            setLlmType(null);
        }
    }, [assetRiskAssessmentRes.isSuccess, assetRiskAssessmentRes.isError]);

    const handleClose = () => {
        props.setShow(false);
    };

    const handleSubmit = (values: any) => {
        if (props.actionType === ACTION_TYPE.ADD_ACTION) {
            if (props.reportName === REPORT_NAME.INVESTMENT_MASTER) {
                const payload = {
                    name: values.name,
                    assetTypeId: parseInt(values.assetTypeId),
                    amount: values.amount,
                    expROI: values.expROI,
                    actualROI: values.actualROI,
                    mandateId: parseInt(values.mandateId),
                    familyOfficeId: parseInt(values.familyOfficeId),
                    startDate: values.startDate,
                    status: true
                }

                saveInvestmentMaster({
                    token: localUserObj?.token,
                    payload: payload,
                });
            } else if (props.reportName === REPORT_NAME.ASSET_TYPE) {
                const payload = {
                    name: values.name,
                    code: values.code,
                    description: values.description,
                    prompt: values.prompt,
                    status: true
                }

                saveAssetType({
                    token: localUserObj?.token,
                    payload: payload,
                });
            } else if (props.reportName === REPORT_NAME.ASSETS) {
                const payload = {
                    name: values.name,
                    code: values.code,
                    currency: values.currency,
                    unitOfMeasurement: values.unitOfMeasurement,
                    quantity: parseInt(values.quantity),
                    assetTypeId: parseInt(values.assetTypeId),
                    entityId: parseInt(values.entityId),
                    entityTypeId: parseInt(values.entityTypeId),
                    investmentMandateTypeId: parseInt(values.investmentMandateTypeId),
                    initialValue: parseInt(values.initialValue),
                    current: values.current,
                    date: values.date,
                    assetOwner: values.assetOwner,
                    purchaserName: values.purchaserName,
                    purchaserPhone: values.purchaserPhone,
                    purchaserEmail: values.purchaserEmail,
                    registrationId: parseInt(values.registrationId),
                    referenceCode: values.referenceCode,
                    healthScore: values.healthScore,
                    status: true
                }

                const formData = new FormData();
                formData.append('assetsReqDTO', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
                formData.append('file1', file);
                formData.append('file2', file2);

                saveAssets({
                    token: localUserObj?.token,
                    payload: formData,
                });
            }

        } else if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            if (props.reportName === REPORT_NAME.INVESTMENT_MASTER) {
                const payload = {
                    id: props?.data?.id,
                    name: values.name,
                    assetTypeId: parseInt(values.assetTypeId),
                    amount: values.amount,
                    expROI: values.expROI,
                    actualROI: values.actualROI,
                    mandateId: parseInt(values.mandateId),
                    familyOfficeId: parseInt(values.familyOfficeId),
                    startDate: values.startDate,
                    status: values.isActive,
                }

                updateInvestmentMaster({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                    payload: payload
                });
            } else if (props.reportName === REPORT_NAME.ASSET_TYPE) {
                const payload = {
                    id: props?.data?.id,
                    name: values.name,
                    code: values.code,
                    description: values.description,
                    prompt: values.prompt,
                    status: values.isActive,
                }

                updateAssetType({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                    payload: payload
                });
            } else if (props.reportName === REPORT_NAME.ASSETS) {
                const payload = {
                    id: props?.data?.id,
                    name: values.name,
                    code: values.code,
                    currency: values.currency,
                    unitOfMeasurement: values.unitOfMeasurement,
                    quantity: parseInt(values.quantity),
                    assetTypeId: parseInt(values.assetTypeId),
                    entityId: parseInt(values.entityId),
                    entityTypeId: parseInt(values.entityTypeId),
                    investmentMandateTypeId: parseInt(values.investmentMandateTypeId),
                    initialValue: parseInt(values.initialValue),
                    current: values.current,
                    date: values.date,
                    assetOwner: values.assetOwner,
                    purchaserName: values.purchaserName,
                    purchaserPhone: values.purchaserPhone,
                    purchaserEmail: values.purchaserEmail,
                    registrationId: parseInt(values.registrationId),
                    referenceCode: values.referenceCode,
                    status: values.isActive,
                }

                const formData = new FormData();
                formData.append('assetsReqDTO', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
                formData.append('file1', file);
                formData.append('file2', file2);

                updateAssets({
                    token: localUserObj?.token,
                    id: props?.data?.id,
                    payload: formData,
                });
            }
        }
    };

    const handleBulkUpload = (e: any) => {

        const file = e.target.files[0];

        const fileName = e.target.files[0].name;
        const extension = fileName.lastIndexOf(".") + 1;
        const extFile = fileName.substr(extension, fileName.length).toLowerCase();

        if (extFile == "xlsx") {
            setFile(e.target.files[0]);
        } else {
            alertMessage("Only xlsx files are allowed!", "error");
        }
    };

    const handleBulkSave = () => {
        if (props.actionType === ACTION_TYPE.ADD_ACTION) {

            const formData = new FormData();
            if (file) {
                formData.append('file', file);
            }

            if (props.reportName === REPORT_NAME.INVESTMENT_MASTER) {
                bulkSaveInvestmentMaster({
                    token: localUserObj?.token,
                    payload: formData
                });
            } else if (props.reportName === REPORT_NAME.ASSET_TYPE) {
                bulkSaveAssetType({
                    token: localUserObj?.token,
                    payload: formData
                });
            } else if (props.reportName === REPORT_NAME.ASSETS) {
                bulkSaveAssets({
                    token: localUserObj?.token,
                    payload: formData
                });
            }
        }
    }

    // upload file...............................
    const fileHandler = (e: any, fileNo: any) => {

        const file = e.target.files[0];
        if (fileNo === "file1") {
            const fileName = e.target.files[0].name;
            setFileName(fileName)
            const extension = fileName.lastIndexOf(".") + 1;
            const extFile = fileName.substr(extension, fileName.length).toLowerCase();
            setFile(e.target.files[0]);
        }

        if (fileNo === "file2") {
            const fileName = e.target.files[0].name;
            setFileName2(fileName)
            const extension = fileName.lastIndexOf(".") + 1;
            const extFile = fileName.substr(extension, fileName.length).toLowerCase();
            setFile2(e.target.files[0]);
        }

    };

    const fileToBase64 = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = error => reject(error);
        });
    };

    const handleAssesment = async (formValues: any, setFieldValue: any) => {
        console.log(formValues)

        let payload = {};

        if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
            payload = {
                parent_entity_id: "",
                parent_entity_name: "",
                user_id: localUserObj.id,
                asset_type: props.data?.assetType ? props.data?.assetType : null,
                asset_name: props.data?.name,
                entity_name: "",
                entity_type: "",
                source: REPORT_NAME.ASSETS,
                actionType: props.actionType,
                assetId: props.data.id,
                prompt: props.data?.assetType?.prompt,
                currency: props.data?.currency,
                unitOfMeasurement: props.data?.unitOfMeasurement,
                quantity: props.data?.quantity,
                investmentMandateType: props.data?.investmentMandateType?.name,
                purchaserName: props.data?.purchaserName,
                fileUpload1: props.data?.fileUpload1,
                fileUpload2: props.data?.fileUpload2,
                // entityMaster: props.data?.entityMaster.name,
                // entityType: props.data?.entityTypeMaster.name,
                // initialValue: props.data?.initialValue,
                // current: props.data?.current,

            };
        } else {
            // 🔥 ADD CASE – convert files to base64
            const file1Base64 = formValues.fileUpload1
                ? await fileToBase64(formValues.fileUpload1)
                : null;

            const file2Base64 = formValues.fileUpload2
                ? await fileToBase64(formValues.fileUpload2)
                : null;

            payload = {
                parent_entity_id: "",
                parent_entity_name: "",
                user_id: localUserObj.id,
                asset_type: parseInt(formValues.assetTypeId)
                    ? allAssetType.find((t: any) => t.id === parseInt(formValues.assetTypeId))?.name
                    : "",
                asset_name: formValues.name,
                entity_name: "",
                entity_type: "",
                source: REPORT_NAME.ASSETS,
                actionType: props.actionType,
                currency: formValues.currency,
                unitOfMeasurement: formValues.unitOfMeasurement,
                quantity: formValues.quantity,
                investmentMandateType: props.data.investmentMandateType.name,
                purchaserName: formValues.purchaserName,
                fileUpload1: file1Base64,
                fileUpload2: file2Base64,
            };
        }
        setLlmType("ASSESSMENT");
        getAssetRiskAssessment({
            token: localUserObj?.token,
            payload: payload,
        })
    };

    const handleAnalyze = async (formValues: any) => {
        // Construct payload for Analyze button
        const payload = {
            actionType: props.actionType,
            source: "ASSET_RISK_ANALYSIS",
            prompt: "please do comprehensive asset risk analysis with referent to asset type / asset owner",
            asset_name: props.actionType === ACTION_TYPE.UPDATE_ACTION ? props.data?.name : formValues.name,
            asset_type: props.actionType === ACTION_TYPE.UPDATE_ACTION
                ? (props.data?.assetType?.name || "")
                : (parseInt(formValues.assetTypeId)
                    ? allAssetType.find((t: any) => t.id === parseInt(formValues.assetTypeId))?.name
                    : ""),
            unitOfMeasurement: props.actionType === ACTION_TYPE.UPDATE_ACTION ? props.data?.unitOfMeasurement : formValues.unitOfMeasurement,
            quantity: props.actionType === ACTION_TYPE.UPDATE_ACTION ? props.data?.quantity : formValues.quantity,
            currency: props.actionType === ACTION_TYPE.UPDATE_ACTION ? props.data?.currency : formValues.currency,
            current: props.actionType === ACTION_TYPE.UPDATE_ACTION ? props.data?.current : formValues.current,
            initialValue: props.actionType === ACTION_TYPE.UPDATE_ACTION ? props.data?.initialValue : formValues.initialValue,
            purchaserName: props.actionType === ACTION_TYPE.UPDATE_ACTION ? props.data?.purchaserName : formValues.purchaserName,
            purchaserEmail: props.actionType === ACTION_TYPE.UPDATE_ACTION ? props.data?.purchaserEmail : formValues.purchaserEmail,
            purchaserPhone: props.actionType === ACTION_TYPE.UPDATE_ACTION ? props.data?.purchaserPhone : formValues.purchaserPhone,
            assetOwner: props.actionType === ACTION_TYPE.UPDATE_ACTION ? props.data?.assetOwner : formValues.assetOwner,
            registrationId: props.actionType === ACTION_TYPE.UPDATE_ACTION ? props.data?.registrationId : formValues.registrationId,
            referenceCode: props.actionType === ACTION_TYPE.UPDATE_ACTION ? props.data?.referenceCode : formValues.referenceCode,
            user_id: localUserObj.id,
        };

        setLlmType("ANALYZE");
        getAssetRiskAssessment({
            token: localUserObj?.token,
            payload: payload,
        });
    };

    useEffect(() => {
        if (!assetRiskAssessment) return;

        const llmRes = assetRiskAssessment;

        if (setFieldValueRef.current) {
            setFieldValueRef.current("llmRes", llmRes);
        }
    }, [assetRiskAssessment]);

    return (
        <>
            <Modal
                show={props.show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                {...(
                    props.reportName === REPORT_NAME.USER_SUBSCRIBER || props.reportName === REPORT_NAME.USER_GROUP
                        ? { dialogClassName: "modal-90w" }
                        : { size: "lg" }
                )}

            >
                <Modal.Header closeButton>

                    <Modal.Title
                        className="fw-bold text-accent"
                        style={{ fontSize: "1rem" }}
                    >
                        {props.actionType === ACTION_TYPE.ADD_ACTION ? "Add" : "Update"}{" "}
                        {props.reportName}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {saveInvestmentMasterResponse.isLoading ||
                        saveAssetTypeResponse.isLoading ||
                        saveAssetsResponse.isLoading ||

                        bulkSaveInvestmentMasterResponse.isLoading ||
                        bulkSaveAssetTypeResponse.isLoading ||
                        bulkSaveAssetsResponse.isLoading ||

                        updateInvestmentMasterResponse.isLoading ||
                        updateAssetTypeResponse.isLoading ||
                        updateAssetsResponse.isLoading ||

                        investmentMasterByIdResponse.isLoading ||
                        assetTypeByIdResponse.isLoading ||
                        assetsByIdResponse.isLoading ||

                        findAllInvestmentMandateTypeResponse.isLoading ||
                        findAllFamilyOfficeMasterResponse.isLoading ||
                        findAllAssetTypeResponse.isLoading

                        ? (
                            <Loading />
                        ) : (
                            ""
                        )
                    }

                    {props.actionType === ACTION_TYPE.ADD_ACTION && (
                        <ul className="nav nav-tabs mb-3" role="tablist">
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'manual' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('manual')}
                                >
                                    Manual Entry
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className={`nav-link ${activeTab === 'bulk' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('bulk')}
                                >
                                    Bulk Upload
                                </button>
                            </li>
                        </ul>
                    )}


                    {activeTab === "manual" && (
                        <Formik
                            validationSchema={validationSchema}
                            validateOnChange={true}
                            validateOnBlur={true}
                            enableReinitialize={true}
                            initialValues={
                                props.reportName === REPORT_NAME.INVESTMENT_MASTER ? {
                                    name:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.name
                                            : "",
                                    assetTypeId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.assetType?.id
                                            : "",
                                    amount:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.amount
                                            : "",
                                    startDate:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.startDate
                                            : "",
                                    expROI:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.expROI
                                            : "",
                                    actualROI:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.actualROI
                                            : "",
                                    mandateId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.mandate?.id
                                            : "",
                                    familyOfficeId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.familyOfficeMaster?.id
                                            : "",
                                } : props.reportName === REPORT_NAME.ASSET_TYPE ? {
                                    name:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.name
                                            : "",
                                    code:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.code
                                            : "",
                                    description:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.description
                                            : "",
                                    prompt:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.prompt
                                            : "",
                                } : props.reportName === REPORT_NAME.ASSETS ? {
                                    name:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.name
                                            : "",
                                    code:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.code
                                            : "",
                                    currency:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.currency
                                            : "",
                                    unitOfMeasurement:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.unitOfMeasurement
                                            : "",
                                    quantity:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.quantity
                                            : "",
                                    assetTypeId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.assetType?.id
                                            : "",
                                    investmentMandateTypeId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.investmentMandateType?.id
                                            : "",
                                    initialValue:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.initialValue
                                            : "",
                                    current:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.current
                                            : "",
                                    date:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.date
                                            : "",
                                    assetOwner:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.assetOwner
                                            : "",
                                    purchaserName:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.purchaserName
                                            : "",
                                    purchaserPhone: props.actionType === ACTION_TYPE.UPDATE_ACTION
                                        ? getByIdData && getByIdData.purchaserPhone
                                        : "",
                                    purchaserEmail: props.actionType === ACTION_TYPE.UPDATE_ACTION
                                        ? getByIdData && getByIdData.purchaserEmail
                                        : "",
                                    registrationId: props.actionType === ACTION_TYPE.UPDATE_ACTION
                                        ? getByIdData && getByIdData.registrationId
                                        : "",
                                    referenceCode:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.referenceCode
                                            : "",
                                    healthScore:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.healthScore
                                            : "",
                                    file1:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.file1
                                            : "",
                                    file2:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.file2
                                            : "",
                                    llmReq:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.llmRequest
                                            : "",
                                    llmRes:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.llmResponse
                                            : "",
                                    entityId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.entityMaster?.id
                                            : "",
                                    entityTypeId:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.entityTypeMaster?.id
                                            : "",
                                    analyzeReq: "",
                                    analyzeRes: "",
                                } : props.reportName === REPORT_NAME.FAMILY_OFFICE_MASTER ? {

                                } : {
                                    name:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.name
                                            : "",
                                    description:
                                        props.actionType === ACTION_TYPE.UPDATE_ACTION
                                            ? getByIdData && getByIdData.description
                                            : "",
                                }

                            }
                            onSubmit={handleSubmit}
                        >
                            {({ values, handleChange, setFieldValue, errors, touched, handleBlur }) => {

                                // Save setFieldValue so useEffect can access it
                                setFieldValueRef.current = setFieldValue;

                                const isAssessmentBtnEnabled = () => {
                                    if (props.actionType === ACTION_TYPE.UPDATE_ACTION) {
                                        return (
                                            props.data?.name && props.data?.name.trim() !== "" &&
                                            props.data?.assetType && props.data.assetType.id !== ""
                                        );
                                    } else {
                                        return (
                                            values.name && values?.name.trim() !== "" &&
                                            values.assetTypeId && values.assetTypeId !== ""
                                        );
                                    }
                                };

                                return (
                                    <Form>
                                        <div>
                                            <div> <div className="d-flex"> <div> {props.reportName} Name</div>
                                                <div style={{ color: "red" }}>*</div>
                                            </div>
                                                <input className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.name}
                                                    name={"name"}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        {props.reportName === REPORT_NAME.INVESTMENT_MASTER ? (
                                            <>
                                                {/* <div className="col-lg-6 mt-2">
                                            <div className="d-flex">
                                                <div>Entity Type</div>
                                            </div>
                                            <select
                                                className="form-select form-textbox"
                                                onChange={handleChange}
                                                name="entityType"
                                                value={values.entityType}
                                            >
                                                <option value="">Select Entity Type</option>
                                                {allEntityTypes?.map((type: string, index: number) => (
                                                    <option key={index} value={type}>
                                                        {type}
                                                    </option>
                                                ))}
                                            </select>
                                        </div> */}
                                                <div className="col-lg-6 mt-2">
                                                    <div className="d-flex">
                                                        <div>Asset Type</div>
                                                    </div>
                                                    <select
                                                        className="form-select form-textbox"
                                                        onChange={handleChange}
                                                        name="assetTypeId"
                                                        value={values.assetTypeId}
                                                    >
                                                        <option value="">Select Asset Type</option>
                                                        {allAssetType?.map((type: any, index: number) => (
                                                            <option key={index} value={type.id}>
                                                                {type.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                {/* <div className="mt-3">
                                            <div>Asset Type</div>
                                            <div>
                                                <input className="form-control form-control-sm w-100"
                                                    type="text"
                                                    aria-label=".form-control-sm example"
                                                    onChange={handleChange}
                                                    value={values.assetType}
                                                    name={"assetType"}
                                                    required
                                                />
                                            </div>
                                        </div> */}
                                                <div className="mt-3">
                                                    <div>Amount</div>
                                                    <input className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.amount}
                                                        name={"amount"}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div>Exp ROI</div>
                                                    <input className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.expROI}
                                                        name={"expROI"}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div>Actual ROI</div>
                                                    <input className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.actualROI}
                                                        name={"actualROI"}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div>Start Date</div>
                                                    <input
                                                        className="form-control form-control-sm w-50"
                                                        type="date"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={
                                                            values.startDate
                                                                ? format(parseISO(values.startDate), "yyyy-MM-dd")
                                                                : ""
                                                        }
                                                        name="startDate"
                                                    />
                                                </div>

                                                <div className="col-lg-6 mt-2">
                                                    <div className="d-flex">
                                                        <div>Investment Mandate Type</div>
                                                    </div>
                                                    <select
                                                        className="form-select form-textbox"
                                                        onChange={handleChange}
                                                        name="mandateId"
                                                        value={values.mandateId}
                                                    >
                                                        <option value="">Select Investment Mandate Type</option>
                                                        {allInvestmentMandateType?.map((type: any, index: number) => (
                                                            <option key={index} value={type.id}>
                                                                {type.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="col-lg-6 mt-2">
                                                    <div className="d-flex">
                                                        <div>Family Office</div>
                                                    </div>
                                                    <select
                                                        className="form-select form-textbox"
                                                        onChange={handleChange}
                                                        name="familyOfficeId"
                                                        value={values.familyOfficeId}
                                                    >
                                                        <option value="">Select Family Office</option>
                                                        {allFamilyOfficeMaster?.map((foMaster: any, index: number) => (
                                                            <option key={index} value={foMaster.id}>
                                                                {foMaster.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                {/* <div className="col-lg-6 mt-2">
                                            <div className="d-flex">
                                                <div>Family Office</div>
                                            </div>
                                            <select
                                                className="form-select form-textbox"
                                                onChange={handleChange}
                                                name="familyOfficeId"
                                                value={values.familyOfficeId}
                                            >
                                                <option value="">Select Entity Type</option>
                                                {allEntityTypes?.map((type: string, index: number) => (
                                                    <option key={index} value={type}>
                                                        {type}
                                                    </option>
                                                ))}
                                            </select>
                                        </div> */}
                                            </>
                                        ) : props.reportName === REPORT_NAME.ASSET_TYPE ? (
                                            <>
                                                <div className="mt-3">
                                                    <div>Code</div>
                                                    <input className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.code}
                                                        name={"code"}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div>Description</div>
                                                    <input className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.description}
                                                        name={"description"}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div>Prompt</div>
                                                    <input className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.prompt}
                                                        name={"prompt"}
                                                    />
                                                </div>

                                            </>
                                        ) : props.reportName === REPORT_NAME.ASSETS ? (
                                            <>
                                                <div className="mt-3">
                                                    <div>Code</div>
                                                    <input className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.code}
                                                        name={"code"}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div>Currency</div>
                                                    <input className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.currency}
                                                        name={"currency"}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div>Unit Of Measurement</div>
                                                    <input className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.unitOfMeasurement}
                                                        name={"unitOfMeasurement"}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div>Quantity</div>
                                                    <input className="form-control form-control-sm w-100"
                                                        type="number"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.quantity}
                                                        name={"quantity"}
                                                    />
                                                </div>
                                                <div className="col-lg-6 mt-2">
                                                    <div className="d-flex">
                                                        <div>Asset Type</div>
                                                    </div>
                                                    <select
                                                        className="form-select form-textbox"
                                                        onChange={handleChange}
                                                        name="assetTypeId"
                                                        value={values.assetTypeId}
                                                    >
                                                        <option value="">Select Asset Type</option>
                                                        {allAssetType?.map((assetType: any, index: number) => (
                                                            <option key={index} value={assetType.id}>
                                                                {assetType.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="mt-3">
                                                    <div className="d-flex">
                                                        <div>Entity</div>
                                                    </div>
                                                    <select
                                                        className="form-select form-textbox"
                                                        name="entityId"
                                                        value={values.entityId}
                                                        onChange={(e: any) => {
                                                            // set entityId normally
                                                            setFieldValue("entityId", e.target.value);

                                                            if (e.target.value) {
                                                                const selectedEntity = allEntityMaster.find(
                                                                    (entity: any) => entity.id === Number(e.target.value)
                                                                );

                                                                if (selectedEntity?.entityType?.id) {
                                                                    setFieldValue("entityTypeId", selectedEntity.entityType.id);
                                                                }
                                                            } else {
                                                                // reset entity type if entity is cleared
                                                                setFieldValue("entityTypeId", "");
                                                            }
                                                        }}
                                                    >
                                                        <option value="">Select Entity</option>
                                                        {allEntityMaster?.map((entity: any, index: number) => (
                                                            <option key={index} value={entity.id}>
                                                                {entity.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="mt-3">
                                                    <div className="d-flex">
                                                        <div>Entity Type</div>
                                                    </div>
                                                    <select
                                                        className="form-select form-textbox"
                                                        onChange={handleChange}
                                                        name="entityTypeId"
                                                        value={values.entityTypeId}
                                                        disabled={!!values.entityId}
                                                    >
                                                        <option value="">Select Entity Type</option>
                                                        {allEntityTypes?.map((type: any, index: number) => (
                                                            <option key={index} value={type.id}>
                                                                {type.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="col-lg-6 mt-2">
                                                    <div className="d-flex">
                                                        <div>Investment Mandate Type</div>
                                                    </div>
                                                    <select
                                                        className="form-select form-textbox"
                                                        onChange={handleChange}
                                                        name="mandateId"
                                                        value={values.mandateId}
                                                    >
                                                        <option value="">Select Investment Mandate Type</option>
                                                        {allInvestmentMandateType?.map((type: any, index: number) => (
                                                            <option key={index} value={type.id}>
                                                                {type.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="mt-3">
                                                    <div>Initial Value</div>
                                                    <input className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.initialValue}
                                                        name={"initialValue"}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div>Current</div>
                                                    <input className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.current}
                                                        name={"current"}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div>Date</div>
                                                    <input
                                                        className="form-control form-control-sm w-50"
                                                        type="date"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={
                                                            values.date
                                                                ? format(parseISO(values.date), "yyyy-MM-dd")
                                                                : ""
                                                        }
                                                        name="date"
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div>Asset Owner</div>
                                                    <input className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.assetOwner}
                                                        name={"assetOwner"}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div>Purchaser Name</div>
                                                    <input className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.purchaserName}
                                                        name={"purchaserName"}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div>Purchaser Phone</div>
                                                    <input className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.purchaserPhone}
                                                        name={"purchaserPhone"}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div>Purchaser Email</div>
                                                    <input className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.purchaserEmail}
                                                        name={"purchaserEmail"}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div>Registration Id</div>
                                                    <input className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.registrationId}
                                                        name={"registrationId"}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div>Reference Code</div>
                                                    <input className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.referenceCode}
                                                        name={"referenceCode"}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div>Health Score</div>
                                                    <input className="form-control form-control-sm w-100"
                                                        type="text"
                                                        aria-label=".form-control-sm example"
                                                        onChange={handleChange}
                                                        value={values.healthScore}
                                                        name={"healthScore"}
                                                    />
                                                </div>
                                                <div className="mt-3">
                                                    <div>File Upload 1</div>
                                                    <div className="d-flex">
                                                        <input
                                                            type="file"
                                                            hidden
                                                            id="fileUpload1"
                                                            onChange={(e: any) => {
                                                                fileHandler(e, "file1");
                                                                setFieldValue("file1", e.target.files[0]);
                                                            }}
                                                        />
                                                        <label htmlFor="fileUpload1" className="btn btn-primary mx-2  mt-3" style={{ width: "30%" }}>Upload file</label>
                                                        <p className="mt-4">{fileName}</p>
                                                    </div>
                                                </div>
                                                <div className="mt-3">
                                                    <div>File Upload 2</div>
                                                    <div className="d-flex">
                                                        <input
                                                            type="file"
                                                            hidden
                                                            id="fileUpload2"
                                                            onChange={(e: any) => {
                                                                fileHandler(e, "file2");
                                                                setFieldValue("file2", e.target.files[0]);
                                                            }}
                                                        />
                                                        <label htmlFor="fileUpload2" className="btn btn-primary mx-2  mt-3" style={{ width: "30%" }}>Upload file</label>
                                                        <p className="mt-4">{fileName2}</p>
                                                    </div>
                                                </div>

                                                <div>
                                                    {/* LLM Response */}
                                                    <label>LLM Response</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows={8}
                                                        value={values.llmRes}
                                                        readOnly
                                                    />
                                                </div>


                                                {values.analyzeRes && (
                                                    <div className="mt-3">
                                                        <hr />
                                                        <h6 className="fw-bold text-success">Asset Analysis</h6>
                                                        <div className="mt-2">
                                                            <label>Analysis Request</label>
                                                            <textarea
                                                                className="form-control"
                                                                rows={3}
                                                                value={values.analyzeReq}
                                                                readOnly
                                                            />
                                                        </div>
                                                        <div className="mt-2">
                                                            <label>Analysis Response</label>
                                                            <textarea
                                                                className="form-control"
                                                                rows={8}
                                                                value={values.analyzeRes}
                                                                readOnly
                                                            />
                                                        </div>
                                                    </div>
                                                )}

                                                <div className="d-flex flex-row">
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary btn-block mt-3 mx-2 btn-width"
                                                        onClick={() => handleAssesment(props.actionType === ACTION_TYPE.UPDATE_ACTION ?
                                                            props.data : values, setFieldValue)}
                                                        disabled={!isAssessmentBtnEnabled()}
                                                    >
                                                        Asset Risk Assessment
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-success btn-block mt-3 mx-2 btn-width"
                                                        onClick={() => handleAnalyze(values)}
                                                        disabled={!isAssessmentBtnEnabled()}
                                                    >
                                                        Analyze
                                                    </button>
                                                </div>
                                            </>
                                        ) : props.reportName === REPORT_NAME.FAMILY_OFFICE_MASTER ? (
                                            <>
                                            </>
                                        ) : null}
                                        < div className="d-flex flex-row justify-content-center">
                                            <button
                                                type="submit"
                                                className={`btn btn-primary btn-block mt-3 mx-2 btn-width bg-accent`}
                                            >
                                                {props.actionType === ACTION_TYPE.ADD_ACTION
                                                    ? "Save"
                                                    : "Update"}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary btn-block mt-3 mx-2 btn-width"
                                                onClick={handleClose}
                                            >
                                                Close
                                            </button>
                                        </div>
                                    </Form>
                                )
                            }}
                        </Formik>
                    )}
                    {activeTab === "bulk" && (
                        <div className="border p-3 rounded">
                            <div className="mb-3">
                                <label htmlFor="xlsxUpload" className="form-label">
                                    Upload .xlsx File <span className="text-danger">*</span>
                                </label>
                                <input
                                    className="form-control"
                                    type="file"
                                    accept=".xlsx"
                                    id="xlsxUpload"
                                    onChange={handleBulkUpload}
                                />
                            </div>
                            <a
                                href={`/templates/${props.reportName === REPORT_NAME.INVESTMENT_MASTER ? 'INVESTMENT_MASTER'
                                    : props.reportName === REPORT_NAME.ASSET_TYPE ? 'ASSET_TYPE'
                                        : props.reportName === REPORT_NAME.ASSETS ? 'ASSETS'
                                            : ''}.xlsx`}

                                download
                                className="btn btn-outline-secondary"
                            >
                                Download Sample .xlsx Template
                            </a>
                            <button
                                className="btn btn-primary mx-2 bg-accent"
                                onClick={handleBulkSave}
                                disabled={!file}
                            >
                                Save
                            </button>
                        </div>
                    )}

                </Modal.Body>
            </Modal >
        </>
    );

};

export default FOInvestmentData;